"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M23 12c0 3.1242-1.2312 5.9526-3.2218 8l-1.4142-1.4545C19.9926 16.8703 21 14.5562 21 12c0-2.5562-1.0074-4.8703-2.636-6.5454L19.7782 4C21.7688 6.0474 23 8.8758 23 12z"
  }), _react.default.createElement("path", {
    d: "M19.5 12c0 2.1301-.8395 4.0586-2.1967 5.4545L15.8891 16c.9953-1.0237 1.6109-2.4379 1.6109-4s-.6156-2.9763-1.6109-4l1.4142-1.4546C18.6605 7.9414 19.5 9.87 19.5 12zM6.6967 17.4545 8.1109 16C7.1156 14.9763 6.5 13.5621 6.5 12s.6156-2.9763 1.611-4L6.6966 6.5454C5.3395 7.9414 4.5 9.87 4.5 12s.8395 4.0586 2.1967 5.4545z"
  }), _react.default.createElement("path", {
    d: "M3 12c0-2.5562 1.0074-4.8703 2.636-6.5454L4.2218 4C2.2312 6.0474 1 8.8758 1 12s1.2312 5.9526 3.2218 8l1.4142-1.4545C4.0074 16.8703 3 14.5562 3 12zm9.4444-.4123 1.3334-5.7597h-.8889L8 12.4106h3.5556l-1.3334 5.7597h.8889L16 11.5877h-3.5556z"
  })];
};

exports.default = _default;